import { Card, CardContent, Typography } from '@mui/material';

interface BoardCardDragPreviewProps {
  projectName: string;
}

// Visual stand-in rendered inside DndKit's <DragOverlay> while a card is
// being dragged. Looks like a board card (so the cursor "carries"
// something recognizable) but with elevated shadow + slight tilt to feel
// "lifted" — Trello / Linear convention.
export function BoardCardDragPreview({
  projectName,
}: BoardCardDragPreviewProps) {
  return (
    <Card
      variant="outlined"
      sx={{
        width: '100%',
        boxShadow: 6,
        transform: 'rotate(-1.5deg)',
        backgroundColor: 'background.paper',
        cursor: 'grabbing',
      }}
    >
      <CardContent sx={{ pr: 2, py: 1.25 }}>
        <Typography variant="body2">{projectName}</Typography>
      </CardContent>
    </Card>
  );
}
